import { Icon } from '@acme/assets';

interface IResultModal {
  title: string;
  description: string;
  type: 'success' | 'error';
  onBack: () => void;
}

export const ResultModal = (props: IResultModal) => {
  return (
    <div className="flex flex-col p-1 gap-6 items-center">
      {props.type === 'success' ? (
        <div className="flex justify-center items-center w-12 h-12 rounded-full bg-green-100">
          <Icon name="check" color="#0E9F6E" className="h-5 w-5" />
        </div>
      ) : (
        <div className="flex justify-center items-center w-12 h-12 rounded-full bg-red-100">
          <Icon name="x-outline" color="#F05252" className="h-5 w-5" />
        </div>
      )}
      <div className="flex flex-col items-center gap-1">
        <div className="leading-tight text-2xl font-bold text-gray-900 text-center">
          {props.title}
        </div>
        <div className="text-base font-normal text-gray-500 text-center">
          {props.description}
        </div>
      </div>
      <div
        className="flex items-center gap-3 text-gray-900 text-sm font-medium cursor-pointer px-5"
        onClick={props.onBack}
      >
        <Icon name="arrow-left" color="#111928" className="h-3.5 w-3.5" />
        <div>Вернуться в раздел</div>
      </div>
    </div>
  );
};
